import React from "react";
import { Row, Col } from "react-bootstrap";

const SettlementSummarySection = ({
  selectedCount,
  totalGrossAmount,
  totalCommissionAmount,
  isTds,
  tdsVal,
  totalTdsAmount,
  finalCDAmount,
  remarks,
  setRemarks,
  loading,
  hasBankInfo,
  onBack,
}) => {
  return (
    <div className="bma-card">
      <div className="bma-card-body">
        <h2 className="bma-card-title mb-3">4. Settlement Summary & Initiate</h2>
        <Row className="g-3 mb-3">
          <Col md={3}>
            <label className="bma-label">Total Selected Transactions</label>
            <input type="text" className="bma-input" value={selectedCount} disabled style={{ fontWeight: "bold" }} />
          </Col>
          <Col md={3}>
            <label className="bma-label">Total Gross Amount (₹)</label>
            <input type="text" className="bma-input" value={`₹ ${totalGrossAmount.toFixed(2)}`} disabled style={{ fontWeight: "bold" }} />
          </Col>
          <Col md={2}>
            <label className="bma-label">Total CD Commission (₹)</label>
            <input type="text" className="bma-input" value={`₹ ${totalCommissionAmount.toFixed(2)}`} disabled style={{ color: "#f59e0b", fontWeight: "bold" }} />
          </Col>
          <Col md={2}>
            <label className="bma-label">TDS Deduction (₹) {isTds ? `(${tdsVal}%)` : "(N/A)"}</label>
            <input type="text" className="bma-input" value={`- ₹ ${totalTdsAmount.toFixed(2)}`} disabled style={{ color: "#ef4444", fontWeight: "bold" }} />
          </Col>
          <Col md={2}>
            <label className="bma-label">Final Amount to CD (₹)</label>
            <input type="text" className="bma-input" value={`₹ ${finalCDAmount.toFixed(2)}`} disabled style={{ color: "#4ade80", fontWeight: "bold", fontSize: "1.1rem" }} />
          </Col>
        </Row>

        <label className="bma-label">Remarks (Optional)</label>
        <textarea
          rows={2}
          className="bma-textarea"
          placeholder="Enter remarks..."
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
          maxLength={250}
        />

        <div className="mt-4 pt-3 border-top d-flex justify-content-end gap-2" style={{ borderColor: "#24283b" }}>
          <button type="button" className="bma-btn-outline" onClick={onBack} disabled={loading}>
            Cancel
          </button>
          <button type="submit" className="bma-btn-red" disabled={loading || selectedCount === 0 || !hasBankInfo}>
            {loading ? "Initiating..." : "→ Initiate Settlement"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettlementSummarySection;